import { hashHistory} from '../../utils/hashHistory';

export function getQueryParamValue(paramValue) {
  const paramObject = {};
  const params = hashHistory.getCurrentLocation().search.slice(1).split('&');
  params.forEach((param) => {
    const [key, value] = param.split('=');
    paramObject[key] = value;
  });
  return paramObject[paramValue];
}
